import React, { useContext } from 'react';

import { Button, TableCell, TableRow } from '@mui/material';
import styled from 'styled-components';

import { SessionSummaryView, StudentSummaryView, SummaryView } from './types';
import { AttendanceContext, View } from '../../context/AttendanceContext';

const BodyCell = styled(TableCell)`
    padding: 0.25rem;
`;

export interface SummaryTableRowProps {
    row: SummaryView;
}

const SummaryTableRow: React.FC<SummaryTableRowProps> = ({ row }) => {
    const { t, view, setStudentId, setClassSessionId } = useContext(AttendanceContext);

    const renderFirstCell = () => {
        switch (view) {
            case View.StudentSummary:
                return (row as SessionSummaryView).name;
            case View.SessionSummary:
                return (row as StudentSummaryView).date;
            default:
                return null;
        }
    };

    const renderLastCell = () => {
        switch (view) {
            case View.StudentSummary:
                return <Button onClick={() => setStudentId(row.studentId)}>{t('student-report')}</Button>;
            case View.SessionSummary:
                return <Button onClick={() => setClassSessionId(row.classSessionId)}>{t('class-report')}</Button>;
            default:
                return null;
        }
    };

    return (
        <TableRow id={row.studentId} tabIndex={-1}>
            <BodyCell>{renderFirstCell()}</BodyCell>
            <BodyCell align={'center'}>{row.presences}</BodyCell>
            <BodyCell align={'center'}>{row.absences}</BodyCell>
            <BodyCell align={'center'}>{row.tardies}</BodyCell>
            <BodyCell align={'center'} padding={'none'}>
                {renderLastCell()}
            </BodyCell>
        </TableRow>
    );
};

export default SummaryTableRow;
